import AddContentsRfq from '../../../../../../client/src/rfq/src/viewmodel/AddContentsRfqViewModel';

import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesAddContentsRfq extends DesBaseRfq {

    constructor() {
        super(AddContentsRfq);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfq.observedAttributes];
    }
    
}

if (!window.customElements.get('des-add-contents-rfq')) {
    window.customElements.define('des-add-contents-rfq', DesAddContentsRfq);
}
